import { CommonModule } from '@angular/common';
import {
    Component,
    EventEmitter,
    inject,
    input,
    OnInit,
    Output,
    Signal
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
    DatiqModalModule,
    emptyDatiqModal,
    IDatiqModal,
} from '@dat/datiq-components-pkg/modal';
import { IqEventBusBrokerService } from '@dat/iq-event-bus';
import { emptyXmaModalData, IIqMcXmaModalData, McQuery } from '../models';
import { IqMcModalStateService } from '../state';

@Component({
    selector: 'iq-mc-modal-extended-market',
    standalone: true,
    imports: [CommonModule, DatiqModalModule, MatButtonModule],
    templateUrl: './iq-mc-modal-extended-market.component.html',
    styleUrl: './iq-mc-modal-extended-market.component.scss',
})
export class IqMcModalExtendedMarketComponent implements OnInit {
    modalData: Signal<IIqMcXmaModalData[]> = input([emptyXmaModalData]);
    query: Signal<McQuery> = input(null);
    id: Signal<string> = input<string>();

    @Output()
    selected: EventEmitter<IIqMcXmaModalData> = new EventEmitter<IIqMcXmaModalData>();

    @Output()
    closed: EventEmitter<void> = new EventEmitter<void>();

    settings: IDatiqModal = emptyDatiqModal;

    private _bus: IqEventBusBrokerService = inject(IqEventBusBrokerService);
    private _state: IqMcModalStateService = inject(IqMcModalStateService);
    constructor() {}

    ngOnInit(): void {
        this.settings = this._state.mapXmaModalSettings();
    }

    close(): void {
        this.closed.emit();
    }

    selectXMarket(geography: IIqMcXmaModalData): void {
        this._bus.dispatch({
            name: 'type:mc-controls:change',
            payload: {
                query: {
                    ...this.query(),
                    geoCode: geography.code,
                },
            },
        });
        this.selected.emit(geography);
        this.close();
    }
}
